// assets/rp-cart.js

// ==================
// This file is helper functions for cart manipulations
// Note that if adding to cart most of the times you can simply trigger the product-form handleSubmit function
// This will automatically handle the cart addition and update the cart bubble + it uses the theme standard cart drawer
// please see in rp-customizer how we use it.
// ==================

// 1) Fetch the entire cart JSON from /cart.js
async function fetchCart() {
  try {
    const response = await fetch("/cart.js", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
      },
    });
    if (!response.ok) {
      console.error("Failed to fetch cart:", response.statusText);
      return null;
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching cart:", error);
    return null;
  }
}

// 2) Update the cart bubble in the header
function updateCartBubble(cart) {
  if (!cart) return;

  // The element that wraps the bubble is #cart-icon-bubble
  const cartIconBubble = document.getElementById("cart-icon-bubble");
  if (!cartIconBubble) {
    return;
  }

  let nonUpsellCount = cart.item_count; // total items
  cart.items.forEach((item) => {
    // If the product has a 'cart-hidden' tag, decrement
    if (
      item.product &&
      item.product.tags &&
      item.product.tags.includes("cart-hidden")
    ) {
      nonUpsellCount--;
    }
  });

  // 3) We either show the bubble with the quantity or hide it
  // The simplest approach: remove any existing bubble markup, then re-inject it if > 0
  // Alternatively, we could do more granular DOM manipulation.

  // Remove any existing bubble div
  const oldBubble = cartIconBubble.querySelector(".cart-count-bubble");
  if (oldBubble) {
    oldBubble.remove();
  }

  // If we have items that are not upsells
  if (nonUpsellCount > 0) {
    const bubble = document.createElement("div");
    bubble.className = "cart-count-bubble";

    // If < 100 items, show the count
    if (nonUpsellCount < 100) {
      const span = document.createElement("span");
      span.setAttribute("aria-hidden", "true");
      span.textContent = nonUpsellCount;
      bubble.appendChild(span);
    }

    // For accessibility
    const srText = document.createElement("span");
    srText.className = "visually-hidden";
    srText.textContent = `Cart has ${nonUpsellCount} items`;
    bubble.appendChild(srText);

    cartIconBubble.appendChild(bubble);
  }
}

// 3) A convenience function to fetch cart + update bubble
async function refreshCartBubble() {
  console.log("Refreshing cart bubble");
  const cart = await fetchCart();
  updateCartBubble(cart);
}

function updateCartContent(newSectionHTML) {
  const cartContainer = document.querySelector("cart-drawer-items");
  console.log(cartContainer);
  if (cartContainer) {
    cartContainer.innerHTML = newSectionHTML;
  }
}

// Use after adding to cart to refresh the cart UI
// Refreshing the bubble works fine but the cart items content is not working
// Better to rely on productForm.handleSubmit() for adding to cart
async function refreshCartUI() {
  try {
    // 1) Fetch the cart items snippet & bubble snippet in parallel
    const [cartSectionHTML, headerSectionHTML] = await Promise.all([
      fetch("/cart?section_id=main-cart-items", {
        method: "GET",
        headers: { "X-Requested-With": "XMLHttpRequest" },
      }).then((res) => res.text()),

      fetch("/cart?section_id=header", {
        method: "GET",
        headers: { "X-Requested-With": "XMLHttpRequest" },
      }).then((res) => res.text()),
    ]);

    // 2) Update the cart contents
    updateCartContent(cartSectionHTML);

    // 3) Update the bubble
    const parser = new DOMParser();
    const doc = parser.parseFromString(headerSectionHTML, "text/html");

    const newBubble = doc.querySelector("#cart-icon-bubble");
    const oldBubble = document.querySelector("#cart-icon-bubble");

    if (newBubble && oldBubble) {
      // Replace the entire bubble’s inner HTML
      oldBubble.innerHTML = newBubble.innerHTML;
    }
  } catch (error) {
    console.error("Error refreshing cart UI:", error);
  }
}

// Expose our functions as needed
window.fetchCart = fetchCart;
window.updateCartBubble = updateCartBubble;
window.refreshCartBubble = refreshCartBubble;
window.refreshCartUI = refreshCartUI;
